import { createSelector } from 'reselect';


export const getIsLoggedIn = state => state.getIn(['shoppingProgress', 'isLoggedIn']);
export const getIsCompleted = state => state.getIn(['shoppingProgress', 'isCompleted']);
export const getCurrentStep = state => state.getIn(['shoppingProgress', 'currentStep']);

export const getBuyProducts = state => state.getIn(['shoppingProgress', 'buyProducts']);
export const getBuyRedeems = state => state.getIn(['shoppingProgress', 'buyRedeems']);
export const getProducts = state => state.getIn(['shoppingProgress', 'products']);
export const getCanShippingSelf = state => state.getIn(['shoppingProgress', 'canShippingSelf']);
export const getCanShippingDelivery = state => state.getIn(['shoppingProgress', 'canShippingDelivery']);
export const getCanShippingTC = state => state.getIn(['shoppingProgress', 'canShippingTC']);
export const getShippingSelfDateList = state => state.getIn(['shoppingProgress', 'shippingSelfDateList']);
export const getShippingDeliveryDateList = state => state.getIn(['shoppingProgress', 'shippingDeliveryDateList']);
export const getShippingTCDateList = state => state.getIn(['shoppingProgress', 'shippingTCDateList']);

export const getDeliveryMethod = state => state.getIn(['shoppingProgress', 'deliveryMethod']);
export const getDeliveryDate = state => state.getIn(['shoppingProgress', 'deliveryDate']);
export const getDeliveryTime = state => state.getIn(['shoppingProgress', 'deliveryTime']);
export const getStoreId = state => state.getIn(['shoppingProgress', 'storeId']);

export const getAllStoreIdNames = state => state.getIn(['shoppingProgress', 'storeIdNames']);
export const getStoreIdNames = createSelector(
  [getAllStoreIdNames, getDeliveryDate],
  (allStoreIdNames, deliveryDate) => {
  	if (deliveryDate === '2018/02/16') {
      return allStoreIdNames.filter(store => [3,6,8].indexOf(store.getIn(['id'])) > -1); // 夢時代店 機場店 巨蛋店
  	} else {
  		return allStoreIdNames;
  	}
  }
)

export const getStoreName = createSelector(
  [getAllStoreIdNames, getStoreId],
  (allStoreIdNames, storeId) => {
    let storeName = '';
    allStoreIdNames.forEach(store => {
      if (`${store.getIn(['id'])}` === `${storeId}`) {
        storeName = store.getIn(['name']);
        return;
      }
    });
    return storeName;
  }
)

export const getPurchaserName = state => state.getIn(['shoppingProgress', 'purchaserName']);
export const getPurchaserGender = state => state.getIn(['shoppingProgress', 'purchaserGender']);
export const getPurchaserEmail = state => state.getIn(['shoppingProgress', 'purchaserEmail']);
export const getPurchaserPhone = state => state.getIn(['shoppingProgress', 'purchaserPhone']);
export const getPurchaserAddress = state => state.getIn(['shoppingProgress', 'purchaserAddress']);
export const getPurchaserCity = state => state.getIn(['shoppingProgress', 'purchaserCity']);

export const getAsPurchaserData = state => state.getIn(['shoppingProgress', 'asPurchaserData']);
export const getDeliveryName = state => state.getIn(['shoppingProgress', 'deliveryName']);
export const getDeliveryGender = state => state.getIn(['shoppingProgress', 'deliveryGender']);
export const getDeliveryPhone = state => state.getIn(['shoppingProgress', 'deliveryPhone']);
export const getDeliveryAddress = state => state.getIn(['shoppingProgress', 'deliveryAddress']);
export const getDeliveryCity = state => state.getIn(['shoppingProgress', 'deliveryCity']);

export const getPaymentMethod = state => state.getIn(['shoppingProgress', 'paymentMethod']);
export const getTCatCity = state => state.getIn(['shoppingProgress', 'tcatCity']);
export const getTCatStation = state => state.getIn(['shoppingProgress', 'tcatStation']);


export const getCouponCode = state => state.getIn(['shoppingProgress', 'couponCode']);
export const getCouponId = state => state.getIn(['shoppingProgress', 'couponId']);
export const getCouponContent = state => state.getIn(['shoppingProgress', 'couponContent']);
export const getGift = state => state.getIn(['shoppingProgress', 'gift']);
export const getGiftId = state => state.getIn(['shoppingProgress', 'giftId']);

export const getInvoiceType = state => state.getIn(['shoppingProgress', 'invoiceType']);
export const getInvoiceUbn = state => state.getIn(['shoppingProgress', 'invoiceUbn']);
export const getInvoiceTitle = state => state.getIn(['shoppingProgress', 'invoiceTitle']);

export const getGreetings = state => state.getIn(['shoppingProgress', 'greetings']);
export const getNote = state => state.getIn(['shoppingProgress', 'note']);

export const getIsAgreeTerms = state => state.getIn(['shoppingProgress', 'isAgreeTerms']);

export const getShippingCost = state => state.getIn(['shoppingProgress', 'shippingCost']);
export const getErrorMessage = state => state.getIn(['shoppingProgress', 'errorMessage']);
export const getCouponDiscount = state => state.getIn(['shoppingProgress', 'couponDiscount']);
export const getPromotionDiscount = state => state.getIn(['shoppingProgress', 'promotionDiscount']);
export const getDeduction = state => state.getIn(['shoppingProgress', 'deduction']);
export const getBalanceDue = state => state.getIn(['shoppingProgress', 'balanceDue']);

export const getUseRedeem = state => state.getIn(['shoppingProgress', 'useRedeem']);
export const getNewRedeem = state => state.getIn(['shoppingProgress', 'newRedeem']);

export const getOrderId = state => state.getIn(['shoppingProgress', 'orderId']);

export const getTaiwanCity = state => state.getIn(['shoppingProgress', 'TaiwanCity']);
export const getIslands = state => state.getIn(['shoppingProgress', 'islands']);
export const getTCatStations = state => state.getIn(['shoppingProgress', 'TCatStations']);


export const getBuySpecials = state => state.getIn(['specials', 'buySpecials']);

export const getTotalAmount = createSelector(
  [getBuyProducts, getProducts, getBuySpecials],
  (buyProducts, products, buySpecials) => {
    let totalAmount = 0;
    buyProducts.keySeq().forEach(productId => {
      totalAmount += +buyProducts.getIn([productId]) * +products.getIn([productId, 'price'])
    });
    buySpecials.valueSeq().forEach(specials => specials.getIn(['buyProductsList']).forEach((buyProducts, index) => {
      totalAmount += specials.getIn(['price']) * buyProducts.getIn(['qty']);
    }));
    return totalAmount;
  }
)

export const getTotalRedeem = createSelector(
  [getBuyRedeems, getProducts],
  (buyRedeems, products) => {
    let totalRedeem = 0;
    buyRedeems.keySeq().forEach(productId => {
      totalRedeem += +buyRedeems.getIn([productId]) * +products.getIn([productId, 'redeem'])
    });
    return totalRedeem;
  }
)

export const getTCatStationName = createSelector(
  [getTCatStations, getTCatStation],
  (TCatStations, TCatStation) => {
    let TCatStationName = '';
    TCatStations.forEach(Station => {
      if (`${Station.getIn(['ID'])}` === `${TCatStation}`) {
        TCatStationName = Station.getIn(['StationName']);
        return;
      }
    });
    return TCatStationName;
  }
)